/* ==========================================================================
   Rook UI Core — Modal Controller
   Web Component: <rk-modal-element>
   ========================================================================== */

if (!customElements.get('rk-modal-element')) {
    class RkModalElement extends HTMLElement {
        constructor() {
            super();
            this.modal = null;
            this.focusableElements = [];
            this.previousFocus = null;
        }

        connectedCallback() {
            this.modal = this.querySelector('.rk-modal');
            if (!this.modal) return;

            this.bindEvents();
            this.setupOpenTriggers();
        }

        bindEvents() {
            // Close buttons (overlay & X)
            this.querySelectorAll('[data-action="close"]').forEach((el) => {
                el.addEventListener('click', () => this.close());
            });

            // ESC key
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape' && this.isOpen()) {
                    this.close();
                }
            });
        }

        setupOpenTriggers() {
            const modalId = this.dataset.modalId || this.modal?.id;
            if (!modalId) return;

            document.querySelectorAll(`[data-modal-open="${modalId}"]`).forEach((trigger) => {
                trigger.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.open();
                });
            });
        }

        isOpen() {
            return this.modal?.classList.contains('rk-modal--active');
        }

        open() {
            if (!this.modal) return;

            this.previousFocus = document.activeElement;
            this.modal.classList.add('rk-modal--active');
            document.body.style.overflow = 'hidden';

            // Trap focus
            this.focusableElements = this.modal.querySelectorAll(
                'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );

            if (this.focusableElements.length > 0) {
                this.focusableElements[0].focus();
            }

            this.dispatchEvent(
                new CustomEvent('rk:modal:open', { bubbles: true, detail: { id: this.modal.id } })
            );
        }

        close() {
            if (!this.modal) return;

            this.modal.classList.remove('rk-modal--active');
            document.body.style.overflow = '';

            if (this.previousFocus) {
                this.previousFocus.focus();
            }

            this.dispatchEvent(
                new CustomEvent('rk:modal:close', { bubbles: true, detail: { id: this.modal.id } })
            );
        }
    }

    customElements.define('rk-modal-element', RkModalElement);
}
